import React from 'react';
import config from '../config';
import styled from 'styled-components'


const SResultsMaths = styled.div`
  align-items: flex-start;
`

interface IResultsMaths {
  scores: any;
}

const ResultsMaths: React.SFC<IResultsMaths> = (props) => {
  const { scores } = props;

  const scoresLength = scores ? Object.keys(scores).length : 0;

  const scoresAvg: number = scores
    ? Object.keys(scores).reduce(
        (pre: number, key: string) => pre + parseFloat(scores[key]),
        0
      ) / scoresLength
    : 0;

  return (
    <SResultsMaths className={"SResultsMaths"}>
      {scoresLength > 1 && (
        <p>
          Average Form: {scoresAvg.toFixed(1)} -{' '}
          {config.formScale[Math.round(scoresAvg)].shortName}
        </p>
      )}
      <p>No. Scores: {scoresLength}</p>
    </SResultsMaths>
  );
};

export default ResultsMaths;
